import React from 'react';
import { HISTORICAL_GOLD_DATA } from '../constants';

const chartConfig = {
  china: {
    label: '中国',
    color: '#EE334E',
  },
  germany: {
    label: '德国',
    color: '#0f172a',
  },
} satisfies Record<string, { label: string; color: string }>;

const HistoryChart: React.FC = () => {
  const maxGold = Math.max(
    ...HISTORICAL_GOLD_DATA.map((item) => Math.max(item.china, item.germany))
  );

  return (
    <div className="w-full min-w-0">
      <div className="rounded-lg border border-border p-3 space-y-2">
        <div className="flex items-center gap-4 text-xs text-default-500">
          <span className="inline-flex items-center gap-1">
            <span className="inline-block h-2 w-2 rounded-full" style={{ backgroundColor: chartConfig.china.color }} />
            {chartConfig.china.label}
          </span>
          <span className="inline-flex items-center gap-1">
            <span className="inline-block h-2 w-2 rounded-full" style={{ backgroundColor: chartConfig.germany.color }} />
            {chartConfig.germany.label}
          </span>
        </div>
        {HISTORICAL_GOLD_DATA.map((item) => (
          <div key={item.year} className="space-y-1">
            <div className="text-xs text-default-500">{item.year}年</div>
            <div className="space-y-1">
              <div className="flex items-center gap-2">
                <span className="w-8 text-[10px] text-default-500">中</span>
                <div className="h-2 flex-1 rounded bg-default-200 overflow-hidden">
                  <div
                    className="h-full"
                    style={{
                      width: `${(item.china / maxGold) * 100}%`,
                      backgroundColor: chartConfig.china.color,
                    }}
                  />
                </div>
                <span className="w-6 text-right text-xs">{item.china}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 text-[10px] text-default-500">德</span>
                <div className="h-2 flex-1 rounded bg-default-200 overflow-hidden">
                  <div
                    className="h-full"
                    style={{
                      width: `${(item.germany / maxGold) * 100}%`,
                      backgroundColor: chartConfig.germany.color,
                    }}
                  />
                </div>
                <span className="w-6 text-right text-xs">{item.germany}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HistoryChart;

